import { I18NextService } from 'angular-i18next';
import { TableHeader } from 'mbs-ui-kit';

export function getTableHeaders(i18: I18NextService, isBuyLicensesAllow = false, isDiscountedPriceShown = true): TableHeader[] {
  const headers: TableHeader[] = [
    {
      name: i18.t('shared:licenses.licenseType'),
      gridColSize: '10fr',
      gridColMin: '100px'
    },
    {
      name: i18.t('shared:licenses.count'),
      gridColSize: '90px',
      gridColMin: '90px',
      isGridColumn: false,
      class: '-start'
    }
  ];
  if (isBuyLicensesAllow) {
    headers.push(
      {
        name: i18.t('shared:licenses.unitListPrice'),
        gridColSize: '5fr',
        gridColMin: '100px',
        class: '-end',
        isGridColumn: false
      },
      {
        name: i18.t('shared:licenses.unitProratedPrice'),
        gridColSize: '5fr',
        gridColMin: '136px',
        isGridColumn: false,
        class: '-end'
      },
      {
        name: i18.t('shared:licenses.totalProratedPrice'),
        gridColSize: '5fr',
        gridColMin: '136px',
        isGridColumn: false,
        class: '-end'
      }
    );

    if (isDiscountedPriceShown) {
      headers.splice(3, 0, {
        name: i18.t('shared:licenses.unitDiscountedPrice'),
        gridColSize: '6fr',
        gridColMin: '180px',
        isGridColumn: false,
        class: '-end'
      });
    }
  }

  return headers;
}
